export const PUBLISHED = '1';
export const SAVED = '2';
export const LATEST = 'latest';
